import Handler from "./Handler";

// Customer reviews (R7.6): the admin Reviews screen. Every call returns { ok, data, message }.
const BASE = "/admin/reviews";
const wrap = (response) => {
    if (response?.success) return { ok: true, data: response?.data?.data || {}, message: response?.data?.message || "" };
    return { ok: false, data: null, message: response?.data?.message || "Could not do that. Try again." };
};
const call = async (config) => wrap(await Handler({ ...config, silent: true }));

export const fetchReviews = (params) => call({ method: "get", url: BASE, params });
export const fetchReviewStats = (params) => call({ method: "get", url: `${BASE}/stats`, params });
export const fetchReviewSettings = () => call({ method: "get", url: `${BASE}/settings` });
export const saveReviewSettings = (payload) => call({ method: "put", url: `${BASE}/settings`, data: payload });
export const setReviewShown = (reviewId, shown, reason) => call({ method: "post", url: `${BASE}/${reviewId}/shown`, data: { shown, ...(reason ? { reason } : {}) } });
export const replyToReview = (reviewId, text) => call({ method: "post", url: `${BASE}/${reviewId}/reply`, data: { text } });
